import { ProductPublicModels } from '@features/products/product';

/*
// Devuelve un nuevo objeto Product con el tipo de imagen predeterminado y el estado actualizado, incluyendo las medias obtenidas a través de getMediaProductView y el color seleccionado.
// Selección de color
// Tipo de imagen predeterminada
// Imagen secundaria
*/
export function productViewTransformer(
    product: ProductPublicModels.PublicProduct,
    definedColor: ProductPublicModels.PublicProductColor,
): ProductPublicModels.PublicProduct {
    return {
        ...product,
        status: {
            ...product.status,
            selectedColor: definedColor || product.status.selectedColor,
        },
    };
}
